import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installPreloadErrorReload } from './app/lib/reload-on-preload-error';
import './styles/globals.css';

// Before the first render: a stale tab fails on its very first lazy route.
installPreloadErrorReload();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
